import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@babel/polyfill'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Line } from 'vue-chartjs'
import Mint from 'mint-ui'
import "lib-flexible/flexible.js"
import 'mint-ui/lib/style.css'
import './assets/font/iconfont.css'
import {doRequest} from './assets/js/funcs'
import {xhrGet,xhrPost} from '@/api/api'

Vue.use(Mint)
Vue.use(ElementUI);
//vant
import { RadioGroup,Toast, Radio,Cell,CellGroup,Button,Dialog ,List,ActionSheet} from 'vant';
import 'vant/lib/index.css';
Vue.use(Toast);
Vue.use(Radio);
Vue.use(Cell);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(List);
Vue.use(ActionSheet);


// 全局注册组件
import './components/register.js'
Vue.prototype.$xhrGet = xhrGet
Vue.prototype.$xhrPost = xhrPost
Vue.prototype.$doRequest = doRequest
Vue.component('line-chart', {
    extends: Line,
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    props: ['chartData', 'options']
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')